import "firebase/auth";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {firebaseApp} from "../model/firebaseApp";


const actionCodeSettings = {
    // URL you want to redirect back to. The domain (www.example.com) for this
    // URL must be in the authorized domains list in the Firebase Console.
    url: `https://${process.env.REACT_APP_DOMAIN}/auth-link`,
    // This must be true.
    handleCodeInApp: true,
};


export const createAuthHandler = async (cb) => {
    const auth = getAuth(firebaseApp);
    return onAuthStateChanged(auth, (user) => {
        cb(user);
        if (user) {
            // console.log('user is logged in');
        } else {
            // console.log('user is logged out');
        }
    });
}



